import styles from './trade-offs-circles.css?url'
export const links = () => [{ rel: 'stylesheet', href: styles }]
export { TradeOffsCircles } from './trade-offs-circles'
